<template>
  <cTable
    ref="table"
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
  >
    <template #showDetails>
      <div style="height: 650px; overflow: auto">
        <Tag
          type="border"
          v-for="item in list"
          :key="item"
          size="large"
          style="height: 32px; line-height: 32px"
        >
          {{ item }}
        </Tag>
      </div>
    </template>
  </cTable>
</template>

<script>
import {
  getOrderStatusList,
  exportOrderStatus,
  getCustomerGroup,
  getNewOrderStatus
} from "@/api/analysis/orderStatusList";
import { getCountry } from "@/api/system/country";
// import { getSelectType } from "@/api/public";
import { getUser } from "@/api/user/internal";
import { getAgent } from "@/api/tracker/agent";
import { getAllClient } from "@/api/user/client";
import cTable from "@/base/common/index";
import { mapMutations, mapActions, mapGetters } from "vuex";
import copyClick from "@/utils/copyClick";
// import format from "@/utils/format";
export default {
  name: "orderStatusList",
  components: {
    cTable
  },
  methods: {
    ...mapMutations(["closeTag"])
  },
  data() {
    return {
      list: [],
      statusId: "",
      methods: {
        list: p => getOrderStatusList(p),
        exportOrderStatus,
        getNewOrderStatus,
        getAgent
      },
      config: {
        height: 630
      },
      modals: {
        details: {
          methods: {
            cancel: () => {
              this.list = [];
            }
          },
          contentSlot: "showDetails",
          config: {
            modalBind: {
              width: 50,
              draggable: true
            },
            modalContentBind: {
              style: {
                height: "650px"
              }
            }
          },
          header: {
            show: () => true,
            btns: [
              {
                name: () => this.$t("all") + this.$t("copy"),
                key: "copy",
                fnName: "copy",
                bind: {
                  type: "primary",
                  style: {
                    margin: "0 10px"
                  }
                }
              }
            ],
            methods: {
              copy: () => {
                let data = this.list.join("\r\n");
                copyClick.copyToClipboard(data, this);
              }
            }
          },
          footer: {
            show: () => false
          }
        }
      },
      header: {
        searchs: [
          {
            key: "dateType",
            placeholder() {
              return this.$t("select") + this.$t("date") + this.$t("type");
            },
            component: "Select",
            options: [],
            clearable: false,
            methods: {
              async list({ field, searchForm }) {
                let res = await this.$sel.getData("POD_RATE_DATE");
                field.options = res;
                searchForm[field.key] = res[0].value;
                this.$forceUpdate();
              }
            }
          },
          {
            key: "startTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("start") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "datetime",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "175px"
              }
            },
            default() {
              return (
                this.$page.format.dateFormat(
                  new Date(new Date().getTime() - 31 * 1000 * 24 * 3600),
                  "YYYY-MM-DD"
                ) + " 00:00:00"
              );
            },
            methods: {
              // format({ searchForm, value, newFormData }) {
              //   newFormData.temp = 1;
              //   return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
              // }
              "on-change"({ searchForm }) {
                searchForm.startTime = searchForm.startTime
                  ? this.$page.format.timeFormat(searchForm.startTime)
                  : "";
              }
            }
          },
          {
            key: "endTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("end") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "datetime",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "175px"
              }
            },
            default: () => {
              return new Date();
            },
            methods: {
              // format({ searchForm, value, newFormData }) {
              //   newFormData.temp = 1;
              //   return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
              // }
              "on-change"({ searchForm }) {
                let time = this.$page.format.timeFormat(searchForm.endTime);
                if (time.slice(-8) === "00:00:00") {
                  time = time.split(" ")[0] + " " + "23:59:59";
                  searchForm.endTime = time;
                }
              }
            }
          },

          {
            key: "from_country",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("allow_depart");
            },
            clearable: true,
            options: [],
            config: { label: "code", value: "code" },
            bind: {
              style: "width:150px"
            }
          },
          {
            key: "to_country",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("allow_arrive");
            },
            clearable: true,
            options: [],
            config: { label: "code", value: "code" },
            bind: {
              style: "width:150px"
            }
          },
          {
            key: "client_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            clearable: true,
            options: [],
            config: { label: "account", value: "id" },
            bind: {
              multiple: true,
              maxTagCount: 1,
              style: "width:150px"
            }
          },
          {
            key: "customer_service_id",
            component: "Select",
            bind: {
              style: "width:150px"
            },
            placeholder() {
              return this.$t("select") + this.$t("serviceAccount");
            },
            options: [],
            config: { label: "account", value: "id" }
          },
          {
            key: "chainOut",
            component: "Select",
            bind: {
              style: "width:150px"
            },
            placeholder() {
              return this.$t("select") + this.$t("domestic")+this.$t('out');
            },
            options: [
							{
								label:this.$t('YES'),
								value:'YES'
							},
							{
								label:this.$t('NO'),
								value:'NO'
							}
						],
          },
					{
					  key: "group_name",
					  component: "Select",
					  bind: {
					    style: "width:150px",
							multiple:true,
							maxTagCount: 1,
					  },
					  placeholder() {
					    return this.$t("select") + this.$t("customer_group");
					  },
						default:[],
					  options: [],
					  config: { label: "group_name", value: "group_name" }
					},
          {
            key: "cod_type",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("order_type");
            },
            clearable: true,
            options: [],
            bind: {
              style: "width:150px"
            },
            methods: {
              async list({ field, searchForm }) {
                field.options = await this.$sel.getData("COD_TYPE");
                this.$forceUpdate();
              }
            }
          },
          {
            key: "deliver",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("localFaction");
            },
            clearable: true,
            options: [],
            config: { label: "agent_name", value: "agent_name" },
            bind: {
              style: "width:140px"
            },
            methods: {
              async list({ field, searchForm }) {
                field.options = (
                  await getAgent({
                    agent_type: "bag",
                    status: "YES",
                    types: "DELIVERY"
                  })
                ).data.payload.rows;
                this.$forceUpdate();
              }
            }
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            bind: {
              style: "width:140px",
              type: "textarea",
              rows: 1
            },
            component: "Input"
          }
        ],
        btns: {
          list: [
            {
              name: this.$t("Press") + this.$t("b2bClient") + this.$t("export"),
              type: "clientExp",
              fnName: "clientExp",
              bind: {
                icon: "md-arrow-down",
                type: "success"
              },
              disabled({ searchForm }) {
                return !searchForm.client_id && !searchForm.group_name;
              }
            },
            {
              name: this.$t("export"),
              type: "export",
              fnName: "export",
              btnBind: {
                type: "primary"
              },
							list:[
								{
									name: this.$t("detail"),
									type: "detail",
									fnName: "export",
								},
								{
									name: this.$t("list"),
									type: "export",
									fnName: "export",
									disabled() {
									  return !this.selectAll.length;
									},
								}
							]
            }
          ],
          methods: {
            export({ searchForm,field }) {
							if(field.type == 'export')return this.exportExc()
              this.handleRequestMethods(
                "list",
                {
                  export: "query",
                  ...searchForm
                },
                true,
                true
              ).then(res => {
                window.open(this.$globalUrl + res.payload);
              });
            },
            clientExp({ searchForm }) {
              this.handleRequestMethods(
                "list",
                {
                  export: "client",
                  ...searchForm
                },
                true,
                true
              ).then(res => {
                window.open(this.$globalUrl + res.payload);
              });
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60
        },
        {
          name: () => this.$t("clientName"),
          align: "center",
          key: "client_name",
          minWidth: 95,
          tooltip: true,
					header:{
						copy:true
					}
        },
        {
          name: () => this.$t("total_out_ticket_nums"),
          align: "center",
          key: "total",
          minWidth: 95,
					header:{
						copy:true
					}
        },
        {
          name: () => this.$t("time_in"),
          align: "center",
          key: "on_the_way_total",
          minWidth: 95,
          component: "Button",
          bind: {
            type: "primary",
            size: "small"
          },
          disabled: ({ row }) => !row.on_the_way_total,
          methods: {
            click: ({ row }) => {
              this.$refs["table"]
                .handleRequestMethods(
                  "getNewOrderStatus",
                  {
                    ...this.$refs["table"].$refs["header"].searchForm,
                    type: "on_the_way_total",
                    client_id: row.client_id
                  },
                  false,
                  true
                )
                .then(res => {
                  if (res.payload.length) {
                    this.list = res.payload;
                    this.$refs["table"]
                      .getModal("details")
                      .open({}, function() {
                        this.setTitle(this.$t("time_in"));
                      });
                  } else {
                    this.$Message.error(this.$t("NoData"));
                  }
                });
            }
          }
        },
        {
          name: () => this.$t("time_in_rate"),
          align: "center",
          key: "on_the_way_rate",
          minWidth: 95
        },
        {
          name: () => this.$t("Arrived delivery Hub"),
          align: "center",
          key: "arrival_warehouse_total",
          minWidth: 95
        },
        {
          name: () => this.$t("Arrived delivery Hub Rate"),
          align: "center",
          key: "arrival_warehouse_rate",
          minWidth: 95
        },
        {
          name: () => this.$t("pod"),
          align: "center",
          key: "pod_total",
          minWidth: 95
        },
        {
          name: () => this.$t("pod_rate"),
          align: "center",
          key: "pod_rate",
          minWidth: 95,
					header:{
						copy:true
					}
        },
        {
          name: () => this.$t("Pending delivery"),
          align: "center",
          key: "C_total",
          minWidth: 95,
          component: "Button",
          bind: {
            type: "primary",
            size: "small"
          },
          disabled: ({ row }) => !row.C_total,
          methods: {
            click: ({ row }) => {
              this.$refs["table"]
                .handleRequestMethods(
                  "getNewOrderStatus",
                  {
                    ...this.$refs["table"].$refs["header"].searchForm,
                    client_id: row.client_id,
                    type: "C_total"
                  },
                  false,
                  true
                )
                .then(res => {
                  if (res.payload.length) {
                    this.list = res.payload;
                    this.$refs["table"]
                      .getModal("details")
                      .open({}, function() {
                        this.setTitle(this.$t("Pending delivery"));
                      });
                  } else {
                    this.$Message.error(this.$t("NoData"));
                  }
                });
            }
          }
        },
        {
          name: () => this.$t("Pending delivery rate"),
          align: "center",
          key: "C_rate",
          minWidth: 95
        },
        {
          name: () => this.$t("outTicket"),
          align: "center",
          key: "deliver_total",
          minWidth: 95,
          component: "Button",
          bind: {
            type: "primary",
            size: "small"
          },
          disabled: ({ row }) => !row.deliver_total,
          methods: {
            click: ({ row }) => {
              this.$refs["table"]
                .handleRequestMethods(
                  "getNewOrderStatus",
                  {
                    ...this.$refs["table"].$refs["header"].searchForm,
                    client_id: row.client_id,
                    type: "deliver_total"
                  },
                  false,
                  true
                )
                .then(res => {
                  if (res.payload.length) {
                    this.list = res.payload;
                    this.$refs["table"]
                      .getModal("details")
                      .open({}, function() {
                        this.setTitle(this.$t("outTicket"));
                      });
                  } else {
                    this.$Message.error(this.$t("NoData"));
                  }
                });
            }
          }
        },
        {
          name: () => this.$t("outTicket_rate"),
          align: "center",
          key: "deliver_rate",
          minWidth: 95
        },
        {
          name: () => this.$t("reserve1"),
          align: "center",
          key: "reserve_total",
          minWidth: 95,
          component: "Button",
          bind: {
            type: "primary",
            size: "small"
          },
          disabled: ({ row }) => !row.reserve_total,
          methods: {
            click: ({ row }) => {
              this.$refs["table"]
                .handleRequestMethods(
                  "getNewOrderStatus",
                  {
                    ...this.$refs["table"].$refs["header"].searchForm,
                    client_id: row.client_id,
                    type: "reserve_total"
                  },
                  false,
                  true
                )
                .then(res => {
                  if (res.payload.length) {
                    this.list = res.payload;
                    this.$refs["table"]
                      .getModal("details")
                      .open({}, function() {
                        this.setTitle(this.$t("reserve1"));
                      });
                  } else {
                    this.$Message.error(this.$t("NoData"));
                  }
                });
            }
          }
        },
        {
          name: () => this.$t("reserve1_rate"),
          align: "center",
          key: "reserve_rate",
          minWidth: 95
        },
        {
          name: () => this.$t("refuse_t"),
          align: "center",
          key: "refusal_total",
          minWidth: 95,
          component: "Button",
          bind: {
            type: "primary",
            size: "small"
          },
          disabled: ({ row }) => !row.refusal_total,
          methods: {
            click: ({ row }) => {
              this.$refs["table"]
                .handleRequestMethods(
                  "getNewOrderStatus",
                  {
                    ...this.$refs["table"].$refs["header"].searchForm,
                    client_id: row.client_id,
                    type: "refusal_total"
                  },
                  false,
                  true
                )
                .then(res => {
                  if (res.payload.length) {
                    this.list = res.payload;
                    this.$refs["table"]
                      .getModal("details")
                      .open({}, function() {
                        this.setTitle(this.$t("refuse_t"));
                      });
                  } else {
                    this.$Message.error(this.$t("NoData"));
                  }
                });
            }
          }
        },
        {
          name: () => this.$t("refuse_t_rate"),
          align: "center",
          key: "refusal_rate",
          minWidth: 95
        },
        {
          name: () => this.$t("addressError"),
          align: "center",
          key: "change_address_total",
          minWidth: 95,
          component: "Button",
          bind: {
            type: "primary",
            size: "small"
          },
          disabled: ({ row }) => !row.change_address_total,
          methods: {
            click: ({ row }) => {
              this.$refs["table"]
                .handleRequestMethods(
                  "getNewOrderStatus",
                  {
                    ...this.$refs["table"].$refs["header"].searchForm,
                    client_id: row.client_id,
                    type: "change_address_total"
                  },
                  false,
                  true
                )
                .then(res => {
                  if (res.payload.length) {
                    this.list = res.payload;
                    this.$refs["table"]
                      .getModal("details")
                      .open({}, function() {
                        this.setTitle(this.$t("addressError"));
                      });
                  } else {
                    this.$Message.error(this.$t("NoData"));
                  }
                });
            }
          }
        },
        {
          name: () => this.$t("addressError_rate"),
          align: "center",
          key: "change_address_rate",
          minWidth: 95
        },
        {
          name: () => this.$t("phoneError"),
          align: "center",
          key: "phone_error_total",
          minWidth: 95,
          component: "Button",
          bind: {
            type: "primary",
            size: "small"
          },
          disabled: ({ row }) => !row.phone_error_total,
          methods: {
            click: ({ row }) => {
              this.$refs["table"]
                .handleRequestMethods(
                  "getNewOrderStatus",
                  {
                    ...this.$refs["table"].$refs["header"].searchForm,
                    client_id: row.client_id,
                    type: "phone_error_total"
                  },
                  false,
                  true
                )
                .then(res => {
                  if (res.payload.length) {
                    this.list = res.payload;
                    this.$refs["table"]
                      .getModal("details")
                      .open({}, function() {
                        this.setTitle(this.$t("phoneError"));
                      });
                  } else {
                    this.$Message.error(this.$t("NoData"));
                  }
                });
            }
          }
        },
        {
          name: () => this.$t("phoneErrorRate"),
          align: "center",
          key: "phone_error_rate",
          minWidth: 95
        },
        {
          name: () => this.$t("PhoneNotResponding"),
          align: "center",
          key: "not_responding_total",
          minWidth: 95,
          component: "Button",
          bind: {
            type: "primary",
            size: "small"
          },
          disabled: ({ row }) => !row.not_responding_total,
          methods: {
            click: ({ row }) => {
              this.$refs["table"]
                .handleRequestMethods(
                  "getNewOrderStatus",
                  {
                    ...this.$refs["table"].$refs["header"].searchForm,
                    client_id: row.client_id,
                    type: "not_responding_total"
                  },
                  false,
                  true
                )
                .then(res => {
                  if (res.payload.length) {
                    this.list = res.payload;
                    this.$refs["table"]
                      .getModal("details")
                      .open({}, function() {
                        this.setTitle(this.$t("PhoneNotResponding"));
                      });
                  } else {
                    this.$Message.error(this.$t("NoData"));
                  }
                });
            }
          }
        },
        {
          name: () => this.$t("PhoneNotRespondingRate"),
          align: "center",
          key: "not_responding_rate",
          minWidth: 95
        },
        {
          name: () => this.$t("orderBlock"),
          align: "center",
          key: "LJ_total",
          minWidth: 95,
          component: "Button",
          bind: {
            type: "primary",
            size: "small"
          },
          disabled: ({ row }) => !row.LJ_total,
          methods: {
            click: ({ row }) => {
              this.$refs["table"]
                .handleRequestMethods(
                  "getNewOrderStatus",
                  {
                    ...this.$refs["table"].$refs["header"].searchForm,
                    client_id: row.client_id,
                    type: "LJ_total"
                  },
                  false,
                  true
                )
                .then(res => {
                  if (res.payload.length) {
                    this.list = res.payload;
                    this.$refs["table"]
                      .getModal("details")
                      .open({}, function() {
                        this.setTitle(this.$t("orderBlock"));
                      });
                  } else {
                    this.$Message.error(this.$t("NoData"));
                  }
                });
            }
          }
        },
        {
          name: () => this.$t("orderBlockRate"),
          align: "center",
          key: "LJ_rate",
          minWidth: 95
        },
				{
				  name: () => this.$t("lost_ticket_nums"),
				  align: "center",
				  key: "Lost_total",
				  minWidth: 95,
				  component: "Button",
				  bind: {
				    type: "primary",
				    size: "small"
				  },
				  disabled: ({ row }) => !row.Lost_total,
				  methods: {
				    click: ({ row }) => {
				      this.$refs["table"]
				        .handleRequestMethods(
				          "getNewOrderStatus",
				          {
				            ...this.$refs["table"].$refs["header"].searchForm,
				            client_id: row.client_id,
				            type: "Lost_total"
				          },
				          false,
				          true
				        )
				        .then(res => {
				          if (res.payload.length) {
				            this.list = res.payload;
				            this.$refs["table"]
				              .getModal("details")
				              .open({}, function() {
				                this.setTitle(this.$t("orderBlock"));
				              });
				          } else {
				            this.$Message.error(this.$t("NoData"));
				          }
				        });
				    }
				  }
				},
				{
				  name: () => this.$t("lost_rate"),
				  align: "center",
				  key: "Lost_rate",
				  minWidth: 95
				},
				{
				  name: () => this.$t("CustomsHold_t"),
				  align: "center",
				  key: "hold_total",
				  minWidth: 95,
				  component: "Button",
				  bind: {
				    type: "primary",
				    size: "small"
				  },
				  disabled: ({ row }) => !row.hold_total,
				  methods: {
				    click: ({ row }) => {
				      this.$refs["table"]
				        .handleRequestMethods(
				          "getNewOrderStatus",
				          {
				            ...this.$refs["table"].$refs["header"].searchForm,
				            client_id: row.client_id,
				            type: "hold_total"
				          },
				          false,
				          true
				        )
				        .then(res => {
				          if (res.payload.length) {
				            this.list = res.payload;
				            this.$refs["table"]
				              .getModal("details")
				              .open({}, function() {
				                this.setTitle(this.$t("CustomsHold_t"));
				              });
				          } else {
				            this.$Message.error(this.$t("NoData"));
				          }
				        });
				    }
				  }
				},
				{
				  name: () => this.$t("CustomsHoldRate_t"),
				  align: "center",
				  key: "hold_rate",
				  minWidth: 95
				},
				{
				  name: () => this.$t("destroy"),
				  align: "center",
				  key: "DS_total",
				  minWidth: 95,
				  component: "Button",
				  bind: {
				    type: "primary",
				    size: "small"
				  },
				  disabled: ({ row }) => !row.DS_total,
				  methods: {
				    click: ({ row }) => {
				      this.$refs["table"]
				        .handleRequestMethods(
				          "getNewOrderStatus",
				          {
				            ...this.$refs["table"].$refs["header"].searchForm,
				            client_id: row.client_id,
				            type: "DS_total"
				          },
				          false,
				          true
				        )
				        .then(res => {
				          if (res.payload.length) {
				            this.list = res.payload;
				            this.$refs["table"]
				              .getModal("details")
				              .open({}, function() {
				                this.setTitle(this.$t("orderBlock"));
				              });
				          } else {
				            this.$Message.error(this.$t("NoData"));
				          }
				        });
				    }
				  }
				},
				{
				  name: () => this.$t("destroy_rate"),
				  align: "center",
				  key: "DS_rate",
				  minWidth: 95
				},
        {
          name: () => this.$t("country_t"),
          align: "center",
          key: "to_country",
          minWidth: 95
        }
      ]
    };
  },
  mounted() {
    this.header.searchs.forEach(async item => {
      if (item.key === "client_id")
        item.options = (await getAllClient()).data.payload.rows;
      if (item.key === "from_country")
        item.options = (
          await getCountry({ allow_depart: 1 })
        ).data.payload.rows;
      if (item.key === "to_country")
        item.options = (
          await getCountry({ allow_arrive: 1 })
        ).data.payload.rows;
      if (item.key === "customer_service_id")
        item.options = (
          await getUser({ standard: "CustomerService" })
        ).data.payload.rows;
      if (item.key === "group_name")
        item.options = (await getCustomerGroup()).data.payload.rows;
    });
  }
};
</script>
